import React from "react";
import AiSkuMappingActions from "../AiSkuMappingActions";
import AiSkuMappingStatus from "../AiSkuMappingStatus";
import useDecideAiSkuMapping from "../hooks/useDecideAiSkuMapping";
import { isMapped } from "../helper";
import { ACTION,HORIZONTAL_TABLE_ROW_HEIGHT } from "../constants";
import { LinkIcon } from "../Styles/Icons";

const SkuMappingColumn = ({ aiSkuMapping }) => {
  const {
    _id: id,
    labProduct = {},
    dentiraProduct = {},
    status,
  } = aiSkuMapping;
  const { decideAiSkuMapping, decisionState, isEditing, setIsEditing } =
    useDecideAiSkuMapping(id, dentiraProduct, labProduct);

  const isReviewed = decisionState !== ACTION.UNDECIDED;
  return (
    <div key={id} style={baseStyles.dataColumn}>
      <div
        style={{ ...baseStyles.dataCell, fontWeight: isReviewed ? 400 : 600 }}
      >
        {labProduct.supplier_product_id}
      </div>

      <div
        style={{ ...baseStyles.dataCell, fontWeight: isReviewed ? 400 : 600 }}
      >
        {labProduct.name}
      </div>
      <div
        style={{
          ...baseStyles.dataCell,
          justifyContent: "center",
          height: "40px",
          padding: "0",
        }}
      >
        {isMapped(status) && <LinkIcon />}
      </div>
      <div
        style={{
          ...baseStyles.dataCell,
          height: "100px",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: "4px",
        }}
      >
        <div style={{ fontWeight: isReviewed ? 400 : 600, fontSize: "16px" }}>
          {dentiraProduct.name}
        </div>
        <div
          style={{
            fontWeight: isReviewed ? 400 : 600,
            fontSize: "14px",
            color: "#666",
          }}
        >
          {dentiraProduct.description}
        </div>
      </div>

      <div style={baseStyles.dataCell}>
        <AiSkuMappingStatus status={status} />
      </div>

      <AiSkuMappingActions
        decideAiSkuMapping={decideAiSkuMapping}
        decisionState={decisionState}
        isEditing={isEditing}
        setIsEditing={setIsEditing}
        baseStyles={baseStyles}
      />
    </div>
  );
};

export default SkuMappingColumn;

const baseStyles = {
  dataColumn: {
    display: "flex",
    flexDirection: "column",
    minWidth: "200px",
    fontWeight: 600,
    fontSize: "16px",
  },

  dataCell: {
    padding: "10px 16px",
    borderLeft: "1px solid #f0f0f0",
    minWidth: "200px",
    display: "flex",
    alignItems: "center",
    color: "#2f2f2f",
    height: HORIZONTAL_TABLE_ROW_HEIGHT,
    background: "#ffffff",
    flexWrap: "wrap",
  },
};
